import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { useCallback, useState } from "react";
import moment from "moment";
import { FiltroRelatorioReceitaDespesa } from "core/features/relatorios/typings";

function useFiltroRelatorioReceitaDespesa() {
  const [filtro, setFiltro] = useState<FiltroRelatorioReceitaDespesa>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    statusId: undefined,
    contaBancariaIds: [],
    contaCategoriaIds: undefined,
    dataFim: moment().format("YYYY-MM-DD"),
    dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
    operacao: undefined,
    centrosDeCustoIds: [],
  });

  const onChangeFiltro = useCallback(
    (_filtro: Partial<FiltroRelatorioReceitaDespesa>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroRelatorioReceitaDespesa;
